import axios from "../plugins/parseAxios";

export class BillPaymentReportApi {
  static getBillPaymentReportBetweenDateByMarket(marketId, startDate, endDate) {
    return axios.post("functions/getBillPaymentReportBetweenDateByMarket", {
      marketId,
      startDate,
      endDate,
    });
  }
  static getBillPaymentReportBetweenDateByProject(formData) {
    return axios.post("functions/getBillPaymentReportBetweenDateByProject", formData);
  }
}